import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import Component from "src/components/Component";
import withAxios, { IAxiosProps } from "src/components/withAxios";
import Enroll from "./components/Enroll";
import { getLevel } from "./levels";
import "./embed.css";

interface IEmbedIndexState {
  schoolLoading: boolean;
  schoolId: number | null;
  schoolNotFound: boolean;
  /** 1–4 = training step; 0 = registration form (handled inside Enroll). */
  trainingLevel: number;
  /** URL/embed step (1–4) kept after the form so survey links match the right audience. */
  entryLevel: number | null;
}

type IEmbedIndexProps = IAxiosProps & RouteComponentProps<{ schoolSlug?: string; level?: string }>;

const LEGACY_CHAMPION_SLUG = "champion";
const LEGACY_CHAMPION_REDIRECT_SLUG_BY_LEVEL: { [level: number]: string } = {
  1: "champions101purposeandprinciples",
  2: "champions101purposeandprinciples",
  3: "champions101TEAM",
  4: "champions101TEAM",
};

class EmbedIndexInner extends Component<IEmbedIndexProps, IEmbedIndexState> {
  public state: IEmbedIndexState = {
    schoolLoading: false,
    schoolId: null,
    schoolNotFound: false,
    trainingLevel: 1,
    entryLevel: null,
  };

  public async componentDidMount() {
    const { schoolSlug, level } = this.props.match.params;
    const parsedLevel = Number(level);

    if (!schoolSlug || !level || !Number.isInteger(parsedLevel) || parsedLevel < 1 || parsedLevel > 4) {
      this.setState({ schoolNotFound: true, schoolLoading: false });
      return;
    }

    const redirectSlug =
      schoolSlug.toLowerCase() === LEGACY_CHAMPION_SLUG
        ? LEGACY_CHAMPION_REDIRECT_SLUG_BY_LEVEL[parsedLevel]
        : undefined;
    const effectiveSchoolSlug = redirectSlug ?? schoolSlug;

    if (redirectSlug !== undefined) {
      this.props.history.replace(`/embed/${redirectSlug}/${parsedLevel}${this.props.location.search}`);
    }

    this.setState({ schoolLoading: true, trainingLevel: parsedLevel, entryLevel: parsedLevel });
    try {
      const res: any = await this.buildGet<any>(this, `/school/getOneSchoolSlug/${effectiveSchoolSlug}`)();
      if (res?.data) {
        this.setState({
          schoolId: res.data.id,
          schoolLoading: false,
        });
      } else {
        this.setState({ schoolNotFound: true, schoolLoading: false });
      }
    } catch {
      this.setState({ schoolNotFound: true, schoolLoading: false });
    }
  }

  public handleAdvanceLevel = () => {
    this.setState((s) => ({ trainingLevel: s.trainingLevel + 1 }));
  };

  public handleFinishLevels = () => {
    this.setState({ trainingLevel: 0 });
  };

  public render() {
    const { schoolSlug } = this.props.match.params;
    const { schoolLoading, schoolNotFound, schoolId, trainingLevel, entryLevel } = this.state;

    const levelConfig =
      trainingLevel >= 1 && trainingLevel <= 4 ? getLevel(trainingLevel) : undefined;

    return (
      <div className="embed-page">
        <Enroll
          schoolSlug={schoolSlug}
          schoolLoading={schoolLoading}
          schoolNotFound={schoolNotFound}
          schoolId={schoolId}
          trainingLevel={trainingLevel}
          entryLevel={entryLevel}
          onAdvanceLevel={this.handleAdvanceLevel}
          onFinishLevels={this.handleFinishLevels}
          levelConfig={levelConfig}
        />
      </div>
    );
  }
}

const EmbedPage = withAxios(EmbedIndexInner);

export default withRouter(EmbedPage as any);
export { EmbedPage };



// WEBPACK FOOTER //
// ./src/pages/home/embed/index.tsx